frappe.ui.form.ControlTime = class ControlTime extends frappe.ui.form.ControlDate {
	set_formatted_input(value) {
		this.$input && this.$input.val(this.format_for_input(value));
	}
	make_input() {
		this.timepicker_only = true;
		super.make_input();
	}
	make_picker() {
		this.set_time_options();
		this.set_timepicker();
		this.refresh();
	}
	set_time_options() {
		let sysdefaults = frappe.boot.sysdefaults;

		this.time_format =
			sysdefaults && sysdefaults.time_format ? sysdefaults.time_format : "HH:mm:ss";
		this.show_seconds = this.time_format.indexOf("s") !== -1;
	}
	set_input(value) {
		super.set_input(value);
	}
	is_24_hour_format() {
		return !/[h]/.test(this.time_format) && !/a/i.test(this.time_format);
	}
	set_timepicker() {
		this.timepicker_namespace = `.frappe_timepicker_${Math.random().toString(36).slice(2)}`;
		this.$input.on(`focus${this.timepicker_namespace}`, () => {
			this.show_timepicker();
		});
		this.$input.on(`input${this.timepicker_namespace}`, () => {
			if (this.$timepicker && this.$timepicker.is(":visible")) {
				this.timepicker_state = this.get_time_parts(this.get_input_value());
				this.init_timepicker_part_input();
				this.render_timepicker_parts_from_input();
			}
		});
		this.$input.on(`keydown${this.timepicker_namespace}`, (e) => {
			if (e.key === " " || e.which === 84) {
				e.preventDefault();
				this.set_now_time();
			} else if (e.key === "F4" || (e.altKey && e.key === "ArrowDown")) {
				e.preventDefault();
				this.show_timepicker();
			}
		});
	}
	show_timepicker() {
		if (this.$input.prop("disabled") || this.$input.prop("readonly")) return;

		this.make_timepicker();
		this.timepicker_state = this.get_time_parts(this.get_input_value() || this.value);
		this.init_timepicker_part_input();
		this.render_timepicker_parts_from_input();
		this.$timepicker.show();
		this.update_timepicker_position();
		this.bind_timepicker_document_events();
		this.focus_timepicker_part("hour");
	}
	init_timepicker_part_input() {
		const hour = this.is_24_hour_format()
			? this.pad_time_part(this.timepicker_state.hours)
			: this.pad_time_part(this.to_12_hour(this.timepicker_state.hours));
		this.timepicker_part_input = {
			hour,
			minute: this.pad_time_part(this.timepicker_state.minutes),
			second: this.pad_time_part(this.timepicker_state.seconds),
		};
	}
	render_timepicker_parts_from_input() {
		if (!this.$timepicker || !this.timepicker_part_input) return;

		this.$timepicker.find('[data-part="hour"]').val(this.localize_digits(this.timepicker_part_input.hour));
		this.$timepicker.find('[data-part="minute"]').val(this.localize_digits(this.timepicker_part_input.minute));
		if (this.show_seconds) {
			this.$timepicker
				.find('[data-part="second"]')
				.val(this.localize_digits(this.timepicker_part_input.second));
		}
		this.update_period_buttons();
	}
	focus_timepicker_part(part, select_all = true) {
		setTimeout(() => {
			const $part = this.$timepicker.find(`[data-part="${part}"]`);
			if ($part.length) {
				this.focus_timepicker_input($part, select_all);
			}
		}, 0);
	}
	focus_timepicker_input($input, select_all = false) {
		const input = $input.get(0);
		$input.focus();
		if (!input) return;

		if (select_all) {
			input.select();
			return;
		}

		const len = $input.val().length;
		if (input.setSelectionRange) {
			input.setSelectionRange(len, len);
		}
	}
	get_next_timepicker_part(part) {
		if (part === "hour") return "minute";
		if (part === "minute" && this.show_seconds) return "second";
		return null;
	}
	get_key_digit(e) {
		if (e.key.length !== 1) return null;
		const digit = this.normalize_digits(e.key).replace(/\D/g, "");
		return digit || null;
	}
	make_timepicker() {
		if (this.$timepicker) return;

		const labels = this.get_timepicker_labels();
		const is_24h = this.is_24_hour_format();
		const period_html = is_24h
			? ""
			: `<div class="frappe-time-picker__period" role="tablist" aria-label="${labels.period}">
					<button type="button" class="frappe-time-picker__period-button" role="tab" data-period="AM">${labels.am}</button>
					<button type="button" class="frappe-time-picker__period-button" role="tab" data-period="PM">${labels.pm}</button>
				</div>`;
		const seconds_html = this.show_seconds
			? `<div class="frappe-time-picker__colon">:</div>
				<div class="frappe-time-picker__field frappe-time-picker__field--second">
					<input class="frappe-time-picker__input" data-part="second" inputmode="numeric" maxlength="2">
					<div class="frappe-time-picker__label">${labels.second}</div>
				</div>`
			: "";
		const modifier_classes = [
			is_24h ? "frappe-time-picker--24h" : "",
			!this.show_seconds ? "frappe-time-picker--no-seconds" : "",
		]
			.filter(Boolean)
			.join(" ");

		this.$timepicker = $(`
			<div class="frappe-time-picker ${modifier_classes}" role="dialog" aria-label="${labels.title}">
				<div class="frappe-time-picker__header">
					<div class="frappe-time-picker__title">${labels.title}</div>
					${period_html}
				</div>
				<div class="frappe-time-picker__body">
					<div class="frappe-time-picker__fields">
						<div class="frappe-time-picker__field">
							<input class="frappe-time-picker__input" data-part="hour" inputmode="numeric" maxlength="2">
							<div class="frappe-time-picker__label">${labels.hour}</div>
						</div>
						<div class="frappe-time-picker__colon">:</div>
						<div class="frappe-time-picker__field">
							<input class="frappe-time-picker__input" data-part="minute" inputmode="numeric" maxlength="2">
							<div class="frappe-time-picker__label">${labels.minute}</div>
						</div>
						${seconds_html}
					</div>
				</div>
				<div class="frappe-time-picker__actions">
					<button type="button" class="frappe-time-picker__action" data-action="now">${labels.now}</button>
					<span class="frappe-time-picker__action-spacer"></span>
					<button type="button" class="frappe-time-picker__action" data-action="cancel">${labels.cancel}</button>
					<button type="button" class="frappe-time-picker__action" data-action="confirm">${labels.confirm}</button>
				</div>
			</div>
		`).appendTo("body");

		this.$timepicker.on("input", "[data-part]", (e) => this.update_timepicker_part(e));
		this.$timepicker.on("keydown", "[data-part]", (e) => this.handle_timepicker_part_keydown(e));
		if (!is_24h) {
			this.$timepicker.on("click", "[data-period]", (e) => {
				this.set_timepicker_period($(e.currentTarget).data("period"));
			});
		}
		this.$timepicker.on("click", "[data-action]", (e) => {
			const action = $(e.currentTarget).data("action");
			if (action === "now") {
				this.set_now_time();
			} else if (action === "confirm") {
				this.confirm_timepicker();
			} else {
				this.hide_timepicker();
			}
		});
		this.$timepicker.on("keydown", (e) => {
			if (e.key === "Escape") {
				e.preventDefault();
				this.hide_timepicker();
			} else if (e.key === "Enter") {
				e.preventDefault();
				this.confirm_timepicker();
			}
		});
	}
	update_timepicker_part(e) {
		const $target = $(e.currentTarget);
		const part = $target.data("part");
		const raw_value = this.normalize_digits($target.val()).replace(/\D/g, "").slice(0, 2);
		const value = this.sanitize_timepicker_part_value(part, raw_value);

		this.timepicker_part_input[part] = value;
		$target.val(this.localize_digits(value));
		this.set_timepicker_part_value(part, value);
	}
	get_timepicker_part_limits(part) {
		if (part === "hour") {
			if (this.is_24_hour_format()) {
				return { min: 0, max: 23 };
			}
			return { min: 1, max: 12 };
		}
		return { min: 0, max: 59 };
	}
	sanitize_timepicker_part_value(part, raw_value) {
		let value = this.normalize_digits(cstr(raw_value)).replace(/\D/g, "").slice(0, 2);
		if (!value) return "";

		const { min, max } = this.get_timepicker_part_limits(part);

		if (value.length === 1) {
			return value;
		}

		let number_value = cint(value);
		number_value = Math.min(Math.max(number_value, min), max);
		return String(number_value);
	}
	set_timepicker_part_value(part, value) {
		if (!value) return;

		const sanitized = this.sanitize_timepicker_part_value(part, value);
		let number_value = cint(sanitized);
		if (part === "hour") {
			if (this.is_24_hour_format()) {
				this.timepicker_state.hours = number_value;
			} else {
				this.timepicker_state.hours = this.to_24_hour(
					number_value,
					this.get_timepicker_period()
				);
			}
		} else if (part === "minute") {
			this.timepicker_state.minutes = number_value;
		} else {
			this.timepicker_state.seconds = number_value;
		}
		this.update_period_buttons();
	}
	handle_timepicker_part_keydown(e) {
		const digit = this.get_key_digit(e);
		if (!digit) return;

		const input = e.currentTarget;
		const $target = $(input);
		const part = $target.data("part");

		if (input.selectionStart !== input.selectionEnd) return;

		const current = cstr(this.timepicker_part_input[part] || "");

		if (current.length < 2) return;

		const next_part = this.get_next_timepicker_part(part);
		if (!next_part) return;

		e.preventDefault();
		const sanitized_digit = this.sanitize_timepicker_part_value(next_part, digit);
		this.timepicker_part_input[next_part] = sanitized_digit;
		this.set_timepicker_part_value(next_part, sanitized_digit);
		this.render_timepicker_parts_from_input();

		const $next = this.$timepicker.find(`[data-part="${next_part}"]`);
		this.focus_timepicker_input($next, false);
	}
	set_timepicker_period(period) {
		const hour = this.to_12_hour(this.timepicker_state.hours);
		this.timepicker_state.hours = this.to_24_hour(hour, period);
		this.update_period_buttons();
	}
	set_now_time() {
		const now = moment();
		this.timepicker_state = {
			hours: now.hours(),
			minutes: now.minutes(),
			seconds: now.seconds(),
		};
		if (this.$timepicker && this.$timepicker.is(":visible")) {
			this.render_timepicker_value();
			this.confirm_timepicker();
		} else {
			const value = this.get_formatted_time(this.timepicker_state);
			this.$input.val(this.localize_time(value));
			this.$input.trigger("change");
		}
	}
	confirm_timepicker() {
		["hour", "minute", "second"].forEach((part) => {
			if (!this.show_seconds && part === "second") return;

			const value = this.sanitize_timepicker_part_value(
				part,
				this.timepicker_part_input[part] || "0"
			);
			this.timepicker_part_input[part] = value;
			this.set_timepicker_part_value(part, value);
		});
		this.render_timepicker_parts_from_input();

		const value = this.get_formatted_time(this.timepicker_state);
		this.$input.val(this.localize_time(value));
		this.$input.trigger("change");
		this.hide_timepicker();
	}
	hide_timepicker() {
		if (!this.$timepicker) return;

		this.$timepicker.hide();
		$(document).off(this.timepicker_namespace);
		$(window).off(this.timepicker_namespace);
	}
	bind_timepicker_document_events() {
		$(document).off(this.timepicker_namespace);
		$(window).off(this.timepicker_namespace);
		setTimeout(() => {
			$(document).on(`mousedown${this.timepicker_namespace}`, (e) => {
				if (
					!this.$timepicker.is(e.target) &&
					this.$timepicker.has(e.target).length === 0 &&
					!this.$input.is(e.target)
				) {
					this.hide_timepicker();
				}
			});
		}, 0);
		$(window).on(`resize${this.timepicker_namespace} scroll${this.timepicker_namespace}`, () => {
			this.update_timepicker_position();
		});
	}
	update_timepicker_position() {
		if (!this.$timepicker || !this.$timepicker.is(":visible")) return;

		const offset = this.$input.offset();
		const input_height = this.$input.outerHeight();
		const picker_width = this.$timepicker.outerWidth();
		const picker_height = this.$timepicker.outerHeight();
		const scroll_top = $(window).scrollTop();
		const window_width = $(window).width();
		const window_height = $(window).height();
		const gap = 8;
		let top = offset.top + input_height + gap;
		let left = offset.left;

		if ($("body").css("direction") === "rtl") {
			left = offset.left + this.$input.outerWidth() - picker_width;
		}
		if (left + picker_width > window_width - 12) {
			left = window_width - picker_width - 12;
		}
		if (left < 12) {
			left = 12;
		}
		if (top + picker_height - scroll_top > window_height - 12) {
			top = offset.top - picker_height - gap;
		}

		this.$timepicker.css({ top, left });
	}
	get_time_parts(value) {
		const normalized_value = this.normalize_time(value || frappe.datetime.now_time());
		let parsed_time = moment(
			normalized_value,
			[this.time_format, frappe.defaultTimeFormat, "HH:mm", "hh:mm A", "h:mm A", "hh:mm:ss A", "h:mm:ss A"],
			true
		);

		if (!parsed_time.isValid()) {
			parsed_time = moment(frappe.datetime.now_time(), frappe.defaultTimeFormat);
		}

		return {
			hours: parsed_time.hours(),
			minutes: parsed_time.minutes(),
			seconds: parsed_time.seconds(),
		};
	}
	render_timepicker_value() {
		this.init_timepicker_part_input();
		this.render_timepicker_parts_from_input();
	}
	update_period_buttons() {
		if (!this.$timepicker || this.is_24_hour_format()) return;

		const period = this.get_timepicker_period();
		this.$timepicker.find("[data-period]").each((index, button) => {
			$(button).toggleClass("active", $(button).data("period") === period);
		});
	}
	get_timepicker_period() {
		return this.timepicker_state.hours >= 12 ? "PM" : "AM";
	}
	to_12_hour(hour) {
		return hour % 12 || 12;
	}
	to_24_hour(hour, period) {
		if (period === "PM") {
			return hour === 12 ? 12 : hour + 12;
		}
		return hour === 12 ? 0 : hour;
	}
	get_formatted_time(time) {
		const formatted_time = moment()
			.hours(time.hours)
			.minutes(time.minutes)
			.seconds(time.seconds || 0)
			.milliseconds(0);

		return formatted_time.format(this.time_format);
	}
	get_timepicker_labels() {
		if (frappe.boot.user.language === "fa") {
			return {
				title: "انتخاب ساعت",
				hour: "ساعت",
				minute: "دقیقه",
				second: "ثانیه",
				period: "نیم روز",
				am: "قبل از ظهر",
				pm: "بعد از ظهر",
				now: "اکنون",
				cancel: "لغو",
				confirm: "تایید",
			};
		}

		return {
			title: "Enter Time",
			hour: __("Hour"),
			minute: __("Minute"),
			second: "Second",
			period: "Period",
			am: "AM",
			pm: "PM",
			now: __("Now"),
			cancel: __("Cancel"),
			confirm: __("OK"),
		};
	}
	normalize_digits(value) {
		const persian_digits = "۰۱۲۳۴۵۶۷۸۹";
		const arabic_digits = "٠١٢٣٤٥٦٧٨٩";

		return cstr(value).replace(/[۰-۹٠-٩]/g, (digit) => {
			let index = persian_digits.indexOf(digit);
			if (index === -1) {
				index = arabic_digits.indexOf(digit);
			}
			return index;
		});
	}
	localize_digits(value) {
		if (frappe.boot.user.language !== "fa") return cstr(value);

		const persian_digits = "۰۱۲۳۴۵۶۷۸۹";
		return cstr(value).replace(/\d/g, (digit) => persian_digits[digit]);
	}
	normalize_time(value) {
		return this.normalize_digits(value)
			.replace(/قبل از ظهر|ق\.ظ/g, "AM")
			.replace(/بعد از ظهر|ب\.ظ/g, "PM")
			.trim();
	}
	localize_time(value) {
		if (frappe.boot.user.language !== "fa") return value;

		if (this.is_24_hour_format()) {
			return this.localize_digits(value);
		}

		return this.localize_digits(value)
			.replace(/\bAM\b/g, "قبل از ظهر")
			.replace(/\bPM\b/g, "بعد از ظهر");
	}
	pad_time_part(value) {
		return String(value).padStart(2, "0");
	}
	set_description() {
		const { description } = this.df;
		const { time_zone } = frappe.sys_defaults;
		if (!frappe.datetime.is_system_time_zone()) {
			if (!description) {
				this.df.description = time_zone;
			} else if (!description.includes(time_zone)) {
				this.df.description += "<br>" + time_zone;
			}
		}
		super.set_description();
	}
	parse(value) {
		if (value) {
			if (value == "Invalid date") {
				value = "";
			}
			value = this.normalize_time(value);
			return frappe.datetime.user_to_str(value, true);
		}
	}
	format_for_input(value) {
		if (value) {
			return this.localize_time(frappe.datetime.str_to_user(value, true));
		}
		return "";
	}
	validate(value) {
		if (!value) return value;

		const normalized = this.normalize_time(value);
		const user_time_fmt = frappe.datetime.get_user_time_fmt();
		const is_valid = moment(
			normalized,
			[user_time_fmt, frappe.defaultTimeFormat, "HH:mm", "HH:mm:ss"],
			true
		).isValid();

		if (!is_valid) {
			frappe.msgprint(
				__("Time {0} must be in format: {1}", [value, user_time_fmt])
			);
			return "";
		}
		return value;
	}
};
